import useSWR from "swr";
import { onlineStockFetcher } from "./onlineStockFetcher";

export function useOnlineStock(
  skuId: string,
  stockApiBaseUrl: string,
  stockApiKey: string,
) {
  return useSWR(
    skuId,
    (skuId) => onlineStockFetcher(skuId, stockApiBaseUrl, stockApiKey),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
}
